(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6844],{

/***/ 34533:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/modul/[modul]",
      function () {
        return __webpack_require__(61336);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _modul_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./components/Layout/Desktop/DesktopLayout.tsx
var DesktopLayout = __webpack_require__(72351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./api/microlearning/useAPIModule.ts
var useAPIModule = __webpack_require__(37802);
// EXTERNAL MODULE: ./stores/microlearning.ts
var microlearning = __webpack_require__(34720);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(98743);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js + 54 modules
var Icon = __webpack_require__(97517);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var text_dist_index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/avatar/dist/index.esm.js + 1 modules
var avatar_dist_index_esm = __webpack_require__(42586);
// EXTERNAL MODULE: ./node_modules/@wartek-id/dialog/dist/index.esm.js + 1 modules
var dialog_dist_index_esm = __webpack_require__(25929);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/pages/MateriVideo.tsx + 1 modules
var MateriVideo = __webpack_require__(47400);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Module/ModuleDetailsPlaceholder.tsx
var ModuleDetailsPlaceholder = __webpack_require__(9363);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Module/PostTestCard.tsx
var PostTestCard = __webpack_require__(54043);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/pages/PostTest.tsx + 9 modules
var PostTest = __webpack_require__(88785);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/CheckmarkNoFill.tsx
var CheckmarkNoFill = __webpack_require__(10854);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/CheckmarkIcon.tsx



var CheckmarkIcon = function(param) {
    var postTestState = param.postTestState;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkNoFill/* default */.Z, {
        "data-testid": postTestState,
        className: (0,clsx_m/* default */.Z)(postTestState === "not_passed" && "text-warning", postTestState === "not_started" && "text-icon-disabled", postTestState === "passed" && "text-success")
    });
};
/* harmony default export */ var components_CheckmarkIcon = (CheckmarkIcon);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Materi/MateriCard.tsx + 2 modules
var MateriCard = __webpack_require__(55312);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/MaterialList.tsx



var MaterialList = function(param) {
    var materialList = param.materialList, query = param.query, toggleMateriExpand = param.toggleMateriExpand, lastExpandedIds = param.lastExpandedIds;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                className: "mb-2",
                variant: "heading-sm",
                children: "Daftar Materi"
            }),
            materialList.sort(function(a, b) {
                return a.id === Number(query.materi) ? -1 : b.id === Number(query.materi) ? 1 : 0;
            }).map(function(materi) {
                var _quiz;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MateriCard/* default */.Z, {
                    query: query,
                    id: materi.id,
                    name: materi.name,
                    quiz: (_quiz = materi.quiz) !== null && _quiz !== void 0 ? _quiz : undefined,
                    isComplete: materi.completed,
                    isShouldRetry: materi.completed && materi.shouldRetry,
                    isExpanded: lastExpandedIds.includes("".concat(query.topik, "_").concat(query.modul, "_").concat(materi.id)),
                    reflective: !!materi.reflective ? materi.reflective : undefined,
                    onClicked: function() {
                        return toggleMateriExpand("".concat(query.topik, "_").concat(query.modul, "_").concat(materi.id));
                    },
                    contents: materi.contents
                }, materi.id);
            })
        ]
    });
};
/* harmony default export */ var components_MaterialList = (MaterialList);

;// CONCATENATED MODULE: ./assets/icons/arrow-alt-right-o.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowAltRightO = function SvgArrowAltRightO(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 3.33301L10.6667 7.99967L6 12.6663",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var arrow_alt_right_o = (SvgArrowAltRightO);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/ModuleDetails.desktop.tsx
/* provided dependency */ var process = __webpack_require__(34155);




















var generatePostTestUrl = function(modulId, modulName, topikId, topikName, postTestState) {
    var from = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", menuId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    var baseUrl = "/pelatihan-mandiri/modul/".concat(modulId, "/post-test");
    if (postTestState === "passed") {
        baseUrl = "".concat(baseUrl, "/passed");
    }
    return "".concat(baseUrl, "?").concat((0,querystring.stringify)({
        topik: topikId,
        topik_name: topikName,
        module_name: modulName,
        postTest: true,
        from: from,
        menuId: menuId,
        testPassed: postTestState === "passed"
    }));
};
var ModuleDetailsDesktop = function(param) {
    var modulePreview = param.modulePreview, isLoading = param.isLoading, isSuccess = param.isSuccess, dialogType = param.dialogType, materialData = param.materialData, _toggleShowDetail = param.toggleShowDetail, toggleShowDetail = _toggleShowDetail === void 0 ? function() {} : _toggleShowDetail, _handleDialogClose = param.handleDialogClose, handleDialogClose = _handleDialogClose === void 0 ? function() {} : _handleDialogClose, _isDrawerOpen = param.isDrawerOpen, isDrawerOpen = _isDrawerOpen === void 0 ? false : _isDrawerOpen, _toggleMateriExpand = param.toggleMateriExpand, toggleMateriExpand = _toggleMateriExpand === void 0 ? function() {} : _toggleMateriExpand, _lastExpandedIds = param.lastExpandedIds, lastExpandedIds = _lastExpandedIds === void 0 ? [] : _lastExpandedIds;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var containerRef = react.useRef(null);
    var ref9 = (0,next_router.useRouter)(), query = ref9.query, back = ref9.back;
    var RenderDetailModuleContent = function() {
        var ref, ref1, ref2, ref3, ref4;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "p-4 pb-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                children: "MODUL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: toggleShowDetail,
                                className: "flex justify-center items-center border-none bg-transparent focus:outline-none",
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    children: "close"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "heading-sm",
                        className: "mt-4",
                        children: modulePreview.data.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        as: "div",
                        className: "simple-wysiwyg-content mb-6 mt-2",
                        dangerouslySetInnerHTML: {
                            __html: modulePreview.data.description
                        }
                    }),
                    ((ref = modulePreview.data.learningMaterial) === null || ref === void 0 ? void 0 : (ref1 = ref.materials) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    variant: "heading-sm",
                                    children: "Daftar Materi:"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                as: "p",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "list-disc pl-5",
                                    children: (ref2 = modulePreview.data.learningMaterial) === null || ref2 === void 0 ? void 0 : ref2.materials.map(function(materi) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: materi.name
                                        }, materi.id);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    as: "span",
                                    variant: "heading-sm",
                                    children: "Langkah Penyelesaian Modul"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                as: "p",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                    className: "list-decimal pl-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Belajar materi"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Refleksi pembelajaran"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Post Test"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                                alt: "",
                                shape: "circle",
                                size: "lg",
                                src: (ref3 = modulePreview.data.reviewer) === null || ref3 === void 0 ? void 0 : ref3.imageUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                                variant: "body-sm",
                                className: "ml-4",
                                children: [
                                    "Ditinjau oleh ",
                                    (ref4 = modulePreview.data.reviewer) === null || ref4 === void 0 ? void 0 : ref4.name
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    var RenderVideoFrameContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MateriVideo/* default */.Z, {
                            modul: query.modul,
                            materi: query.materi,
                            id: query.videoId,
                            topik: query.topik,
                            topik_name: query.topik_name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col p-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row items-center justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: handleDialogClose,
                                className: "flex justify-center items-center border-none bg-transparent focus:outline-none",
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    children: "close"
                                })
                            })
                        })
                    })
                ]
            })
        });
    };
    var RenderPostTestContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTest/* default */.C, {})
        });
    };
    var _topik_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Topik ",
                        (_topik_name = query.topik_name) !== null && _topik_name !== void 0 ? _topik_name : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row",
                children: [
                    query.from && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                        as: "i",
                        className: "mr-2",
                        onClick: back,
                        children: "arrow_back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                className: (0,clsx_m/* default */.Z)("pb-1"),
                                children: "MODUL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                className: (0,clsx_m/* default */.Z)("pb-3"),
                                variant: "heading-lg",
                                children: modulePreview === null || modulePreview === void 0 ? void 0 : (ref = modulePreview.data) === null || ref === void 0 ? void 0 : ref.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: containerRef,
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleDetailsPlaceholder/* default */.Z, {}),
                    isSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-testid": "success-fetch",
                                className: "relative z-0 bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-4 pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-[3vw]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                                                                alt: "",
                                                                shape: "circle",
                                                                size: "lg",
                                                                src: (ref1 = modulePreview.data.reviewer) === null || ref1 === void 0 ? void 0 : ref1.imageUrl
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                                                            variant: "body-sm",
                                                            className: "ml-4",
                                                            children: [
                                                                "Ditinjau oleh ",
                                                                (ref2 = modulePreview.data.reviewer) === null || ref2 === void 0 ? void 0 : ref2.name
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    "data-testid": "toggle-detail",
                                                    onClick: toggleShowDetail,
                                                    className: "flex justify-center items-center border-none bg-transparent focus:outline-none",
                                                    type: "button",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                            variant: "action",
                                                            className: "mr-1 underline w-[10vw]",
                                                            children: "Baca detail modul"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_alt_right_o, {
                                                            className: "stroke-current"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "my-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaterialList, {
                                            materialList: materialData === null || materialData === void 0 ? void 0 : materialData.data,
                                            query: query,
                                            toggleMateriExpand: toggleMateriExpand,
                                            lastExpandedIds: lastExpandedIds
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            className: "mb-2 mt-6",
                                            variant: "heading-sm",
                                            children: "Post Test"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTestCard/* default */.Z, {
                                                href: generatePostTestUrl(String(query.modul), String(modulePreview.data.name), String(query.topik), String(query.topik_name), (ref3 = modulePreview.data.postTest) === null || ref3 === void 0 ? void 0 : ref3.state, query.from, query.menuId),
                                                title: "Kerjakan post test",
                                                description: ((ref4 = modulePreview.data.postTest) === null || ref4 === void 0 ? void 0 : ref4.state) === "not_passed" ? "Post test perlu diulang" : "Evaluasi pemahaman modul",
                                                isLocked: !((ref5 = modulePreview.data.learningMaterial) === null || ref5 === void 0 ? void 0 : ref5.completed),
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckmarkIcon, {
                                                    postTestState: (ref6 = modulePreview.data.postTest) === null || ref6 === void 0 ? void 0 : ref6.state
                                                }),
                                                trackStep: function() {
                                                    return (0,googleAnalytics/* GATrackEvent */.l)({
                                                        eventName: "learning_activity",
                                                        eventParams: {
                                                            event_trigger: "click_module_activity_card",
                                                            action_type: "click_module_activity",
                                                            meta: JSON.stringify({
                                                                topik_id: String(query.topik),
                                                                module_id: String(query.modul),
                                                                type: "post_test"
                                                            })
                                                        },
                                                        sendDefaultParams: true
                                                    });
                                                }
                                            })
                                        }),
                                        ((ref7 = modulePreview.data.postTest) === null || ref7 === void 0 ? void 0 : ref7.state) === "not_passed" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTestCard/* default */.Z, {
                                                href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/modul/").concat(query.modul, "/post-test-history?").concat((0,querystring.stringify)({
                                                    topik: query.topik,
                                                    topik_name: query.topik_name
                                                })),
                                                title: "Hasil post test terakhir",
                                                description: dayjs_min_default()().format("DD/MM/YYYY"),
                                                isLocked: !((ref8 = modulePreview.data.learningMaterial) === null || ref8 === void 0 ? void 0 : ref8.completed),
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    children: "history"
                                                }),
                                                trackStep: function() {
                                                    return (0,googleAnalytics/* GATrackEvent */.l)({
                                                        eventName: "learning_activity",
                                                        eventParams: {
                                                            event_trigger: "click_module_activity_card",
                                                            action_type: "click_module_activity",
                                                            meta: JSON.stringify({
                                                                topik_id: String(query.topik),
                                                                module_id: String(query.modul),
                                                                type: "post_test"
                                                            })
                                                        },
                                                        sendDefaultParams: true
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog_dist_index_esm/* Dialog */.Vq, {
                                isOpen: isDrawerOpen,
                                size: dialogType === "video" || dialogType === "post-test" ? "lg" : "sm",
                                // @ts-ignore it do support customSize string
                                customSize: dialogType === "video" ? "85vw" : 0,
                                onClose: handleDialogClose,
                                closeOnOverlayClick: false,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_dist_index_esm/* DialogOverlay */.t9, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog_dist_index_esm/* DialogContent */.cZ, {
                                        children: [
                                            dialogType === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderVideoFrameContent, {}),
                                            dialogType === "module-detail" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderDetailModuleContent, {}),
                                            dialogType === "post-test" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderPostTestContent, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModuleDetails_desktop = (ModuleDetailsDesktop);

// EXTERNAL MODULE: ./node_modules/@wartek-id/sheet/dist/index.esm.js + 3 modules
var sheet_dist_index_esm = __webpack_require__(34088);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Module/ModuleDrawer.tsx





var ModuleDrawer = function(param) {
    var modul = param.modul, reviewer = param.reviewer, materials = param.materials, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _onSheetClosed = param.onSheetClosed, onSheetClosed = _onSheetClosed === void 0 ? function() {} : _onSheetClosed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* Sheet */.yo, {
        autoFocus: false,
        isOpen: isOpen,
        onClose: onSheetClosed,
        position: "bottom",
        returnFocus: true,
        sheetSize: "lg",
        type: "modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetOverlay */.lu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetContent */.ue, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetTitle */.bC, {
                        children: "MODUL"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetBody */.Fm, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-4 min-h-[200px] bg-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        variant: "heading-lg",
                                        children: modul.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    as: "div",
                                    className: "simple-wysiwyg-content mb-6",
                                    dangerouslySetInnerHTML: {
                                        __html: modul.description
                                    }
                                }),
                                (materials === null || materials === void 0 ? void 0 : materials.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                variant: "heading-sm",
                                                children: "Daftar Materi:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            as: "p",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "list-disc pl-5",
                                                children: materials.map(function(materi) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: materi.name
                                                    }, materi.id);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                as: "span",
                                                variant: "heading-sm",
                                                children: "Langkah Penyelesaian Modul"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            as: "p",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                className: "list-decimal pl-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Belajar materi"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Refleksi pembelajaran"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "Post Test"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-4 border-t border-subdued",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mr-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                            variant: "body-sm",
                                                            children: "Dikembangkan oleh"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                            variant: "heading-md",
                                                            children: reviewer.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                                                        alt: "",
                                                        shape: "circle",
                                                        size: "md",
                                                        src: reviewer.imageUrl
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                children: reviewer.about
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetCloseButton */.Sv, {
                        "data-testid": "close-drawer",
                        onClick: onSheetClosed
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Module_ModuleDrawer = (ModuleDrawer);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/ModulePageHeading.tsx




var ModulePageHeading = function(param) {
    var name = param.name, reviewer = param.reviewer, onToggleClick = param.onToggleClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4 py-4 bg-expressive-dark-blue text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                    as: "span",
                    variant: "body-sm",
                    color: "inverse",
                    className: "uppercase",
                    children: "Modul"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                    variant: "heading-lg",
                    color: "inverse",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 w-6 h-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.q, {
                            name: reviewer === null || reviewer === void 0 ? void 0 : reviewer.name,
                            alt: "",
                            shape: "circle",
                            size: "sm",
                            src: reviewer === null || reviewer === void 0 ? void 0 : reviewer.imageUrl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                            variant: "body-sm",
                            color: "inverse",
                            children: [
                                "Dikembangkan oleh ",
                                reviewer === null || reviewer === void 0 ? void 0 : reviewer.name
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    "data-testid": "toggle-detail",
                    onClick: onToggleClick,
                    className: "flex justify-center items-center border-none bg-transparent focus:outline-none",
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            variant: "action",
                            color: "inverse",
                            className: "mr-1 underline",
                            children: "Baca detail modul"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_alt_right_o, {
                            className: "text-white stroke-current"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ModulePageHeading = (ModulePageHeading);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/ModuleDetails.mobile.tsx
/* provided dependency */ var ModuleDetails_mobile_process = __webpack_require__(34155);















var ModuleDetails_mobile_generatePostTestUrl = function(modulId, modulName, topikId, topikName, postTestState) {
    var from = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", menuId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    var baseUrl = "/pelatihan-mandiri/modul/".concat(modulId, "/post-test");
    if (postTestState === "passed") {
        baseUrl = "".concat(baseUrl, "/passed");
    }
    return "".concat(baseUrl, "?").concat((0,querystring.stringify)({
        topik: topikId,
        topik_name: topikName,
        module_name: modulName,
        postTest: true,
        from: from,
        menuId: menuId,
        testPassed: postTestState === "passed"
    }));
};
var ModuleDetailsMobile = function(param) {
    var modulePreview = param.modulePreview, isLoading = param.isLoading, isSuccess = param.isSuccess, materialData = param.materialData, toggleShowDetail = param.toggleShowDetail, toggleMateriExpand = param.toggleMateriExpand, isDrawerOpen = param.isDrawerOpen, lastExpandedIds = param.lastExpandedIds, _setIsDrawerOpen = param.setIsDrawerOpen, setIsDrawerOpen = _setIsDrawerOpen === void 0 ? function() {} : _setIsDrawerOpen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var containerRef = react.useRef(null);
    var _topik_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Topik ",
                        (_topik_name = query.topik_name) !== null && _topik_name !== void 0 ? _topik_name : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: containerRef,
                className: "bg-gray-5 ",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleDetailsPlaceholder/* default */.Z, {}),
                    isSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModulePageHeading, {
                                name: modulePreview.data.name,
                                reviewer: {
                                    name: (ref = modulePreview.data.reviewer) === null || ref === void 0 ? void 0 : ref.name,
                                    imageUrl: (ref1 = modulePreview.data.reviewer) === null || ref1 === void 0 ? void 0 : ref1.imageUrl
                                },
                                onToggleClick: toggleShowDetail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-testid": "success-fetch",
                                className: "relative z-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-4 pb-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaterialList, {
                                            materialList: materialData === null || materialData === void 0 ? void 0 : materialData.data,
                                            query: query,
                                            toggleMateriExpand: toggleMateriExpand,
                                            lastExpandedIds: lastExpandedIds
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                    className: "mb-2 mt-6",
                                                    variant: "heading-sm",
                                                    children: "Post Test"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTestCard/* default */.Z, {
                                                        href: ModuleDetails_mobile_generatePostTestUrl(String(query.modul), String(modulePreview.data.name), String(query.topik), String(query.topik_name), (ref2 = modulePreview.data.postTest) === null || ref2 === void 0 ? void 0 : ref2.state),
                                                        title: "Kerjakan post test",
                                                        description: ((ref3 = modulePreview.data.postTest) === null || ref3 === void 0 ? void 0 : ref3.state) === "not_passed" ? "Post test perlu diulang" : "Evaluasi pemahaman modul",
                                                        isLocked: !((ref4 = modulePreview.data.learningMaterial) === null || ref4 === void 0 ? void 0 : ref4.completed),
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckmarkIcon, {
                                                            postTestState: (ref5 = modulePreview.data.postTest) === null || ref5 === void 0 ? void 0 : ref5.state
                                                        }),
                                                        trackStep: function() {
                                                            return (0,googleAnalytics/* GATrackEvent */.l)({
                                                                eventName: "learning_activity",
                                                                eventParams: {
                                                                    event_trigger: "click_module_activity_card",
                                                                    action_type: "click_module_activity",
                                                                    meta: JSON.stringify({
                                                                        topik_id: String(query.topik),
                                                                        module_id: String(query.modul),
                                                                        type: "post_test"
                                                                    })
                                                                },
                                                                sendDefaultParams: true
                                                            });
                                                        }
                                                    })
                                                }),
                                                ((ref6 = modulePreview.data.postTest) === null || ref6 === void 0 ? void 0 : ref6.state) === "not_passed" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTestCard/* default */.Z, {
                                                        href: "/".concat(ModuleDetails_mobile_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/modul/").concat(query.modul, "/post-test-history?").concat((0,querystring.stringify)({
                                                            topik: query.topik,
                                                            topik_name: query.topik_name
                                                        })),
                                                        title: "Hasil post test terakhir",
                                                        description: dayjs_min_default()().format("DD/MM/YYYY"),
                                                        isLocked: !((ref7 = modulePreview.data.learningMaterial) === null || ref7 === void 0 ? void 0 : ref7.completed),
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            children: "history"
                                                        }),
                                                        trackStep: function() {
                                                            return (0,googleAnalytics/* GATrackEvent */.l)({
                                                                eventName: "learning_activity",
                                                                eventParams: {
                                                                    event_trigger: "click_module_activity_card",
                                                                    action_type: "click_module_activity",
                                                                    meta: JSON.stringify({
                                                                        topik_id: String(query.topik),
                                                                        module_id: String(query.modul),
                                                                        type: "post_test"
                                                                    })
                                                                },
                                                                sendDefaultParams: true
                                                            });
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Module_ModuleDrawer, {
                                isOpen: isDrawerOpen,
                                onSheetClosed: function() {
                                    setIsDrawerOpen(false);
                                },
                                modul: {
                                    name: modulePreview.data.name,
                                    description: modulePreview.data.description
                                },
                                reviewer: {
                                    name: (ref8 = modulePreview.data.reviewer) === null || ref8 === void 0 ? void 0 : ref8.name,
                                    imageUrl: (ref9 = modulePreview.data.reviewer) === null || ref9 === void 0 ? void 0 : ref9.imageUrl,
                                    about: (ref10 = modulePreview.data.reviewer) === null || ref10 === void 0 ? void 0 : ref10.about
                                },
                                materials: (ref11 = modulePreview.data.learningMaterial) === null || ref11 === void 0 ? void 0 : ref11.materials.map(function(materi) {
                                    return {
                                        id: materi.id,
                                        name: materi.name
                                    };
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModuleDetails_mobile = (ModuleDetailsMobile);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/ModuleDetails.tsx











var ModuleDetails = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref = (0,next_router.useRouter)(), query = ref.query, back = ref.back;
    var ref1 = (0,react.useState)("module-detail"), dialogType = ref1[0], setDialogType = ref1[1];
    var modulePreview = (0,useAPIModule/* useGetModulePreview */.z)(query.modul);
    var ref2 = (0,useAPIModule/* useGetMaterialByModule */.I)(query.modul), materialDataIsLoading = ref2.isLoading, materialDataIsSuccess = ref2.isSuccess, materialData = ref2.data, refetchMaterialData = ref2.refetch;
    var ref3 = (0,react.useState)(false), isDrawerOpen = ref3[0], setIsDrawerOpen = ref3[1];
    var ref4 = (0,microlearning/* useModuleExpanderStore */.ZT)(), lastExpandedIds = ref4.lastExpandedIds, setLastExpandedIds = ref4.setLastExpandedIds;
    var isLoading = modulePreview.isLoading || materialDataIsLoading;
    var isSuccess = modulePreview.isSuccess && materialDataIsSuccess;
    var isInitialSet = react.useRef(false);
    react.useEffect(function() {
        if (!!query.materi && !isInitialSet.current) {
            var referredMateri = "".concat(query.topik, "_").concat(query.modul, "_").concat(query.materi);
            if (!lastExpandedIds.includes(referredMateri)) {
                setLastExpandedIds((0,_to_consumable_array/* default */.Z)(lastExpandedIds).concat([
                    referredMateri
                ]));
            }
            isInitialSet.current = true;
        }
        if (query.videoId) {
            setDialogType("video");
            setIsDrawerOpen(true);
        }
        if (query.postTest) {
            setDialogType("post-test");
            setIsDrawerOpen(true);
        }
        if (!query.videoId && !query.postTest) {
            setIsDrawerOpen(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastExpandedIds,
        setLastExpandedIds,
        query
    ]);
    var toggleShowDetail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDialogType("module-detail");
                        return [
                            4,
                            setIsDrawerOpen(function(isShown) {
                                return !isShown;
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (isDrawerOpen) {
                            (0,googleAnalytics/* GATrackEvent */.l)({
                                eventName: "learning_activity",
                                eventParams: {
                                    event_trigger: "click_view_module_detail",
                                    action_type: "view_module_detail",
                                    meta: JSON.stringify({
                                        module_id: query.modul
                                    })
                                },
                                sendDefaultParams: true
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleShowDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleMateriExpand = function(currentId) {
        if (lastExpandedIds.includes(currentId)) {
            return setLastExpandedIds(lastExpandedIds.filter(function(id) {
                return id !== currentId;
            }));
        }
        return setLastExpandedIds((0,_to_consumable_array/* default */.Z)(lastExpandedIds).concat([
            currentId
        ]));
    };
    var handleDialogClose = function() {
        setIsDrawerOpen(false);
        if (dialogType === "video") {
            refetchMaterialData();
            modulePreview.refetch();
            back();
        }
    };
    if (isDesktop) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleDetails_desktop, {
            modulePreview: modulePreview === null || modulePreview === void 0 ? void 0 : modulePreview.data,
            materialData: materialData,
            isLoading: isLoading,
            isSuccess: isSuccess,
            dialogType: dialogType,
            toggleShowDetail: toggleShowDetail,
            toggleMateriExpand: toggleMateriExpand,
            isDrawerOpen: isDrawerOpen,
            handleDialogClose: handleDialogClose,
            lastExpandedIds: lastExpandedIds
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleDetails_mobile, {
        modulePreview: modulePreview === null || modulePreview === void 0 ? void 0 : modulePreview.data,
        isLoading: isLoading,
        isSuccess: isSuccess,
        materialData: materialData,
        toggleShowDetail: toggleShowDetail,
        toggleMateriExpand: toggleMateriExpand,
        isDrawerOpen: isDrawerOpen,
        setIsDrawerOpen: setIsDrawerOpen,
        lastExpandedIds: lastExpandedIds
    });
};
/* harmony default export */ var pages_ModuleDetails = (ModuleDetails);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/ModulPage/ModulIndexPage.mobile.tsx


var ModulPageMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_ModuleDetails, {});
};

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/ModulPage/DefaultEmptyModulDetail.desktop.tsx



// default empty modul
var DefaultEmptyModulDetail = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[80vh] flex items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                    fontSize: "large",
                    children: "book"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                    variant: "heading-md",
                    className: "text-center mt-8",
                    children: "Untuk memulai, pilih salah satu materi terlebih dahulu"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                    color: "subdued",
                    className: "text-center",
                    children: "Pastikan koneksi internet Anda aktif untuk memuat halaman ini."
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/ModulPage/index.tsx




var ModulPage = function(param) {
    var isDesktop = param.isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultEmptyModulDetail, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModulPageMobile, {});
};

;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/modul/[modul]/index.tsx










var fauxHeaderBg = "before:absolute before:h-14 before:w-full before:top-0 before:bg-expressive-dark-blue before:z-0 z-10";
var ModulePage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var _topik_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopLayout/* WithLayoutListener */.nc, {
        isDesktop: isDesktopScreenSize,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Topik ",
                        (_topik_name = query.topik_name) !== null && _topik_name !== void 0 ? _topik_name : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModulPage, {
                isDesktop: isDesktopScreenSize
            })
        ]
    });
};
var PageHeader = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBar */.h_, {
        inverse: true,
        fixed: true,
        variant: "transparent",
        className: fauxHeaderBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarLeftAction */.l8, {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                as: "i",
                color: "inverse",
                children: "arrow_back"
            }),
            onClick: function() {
                return dist_history/* backToApp */.NU(router.back);
            }
        })
    });
};
ModulePage.layoutOpts = {
    hasHeader: true,
    className: (0,clsx_m/* default */.Z)(fauxHeaderBg, "before:-mt-14"),
    header: PageHeader,
    enableDesktopLayout: true
};
/* harmony default export */ var _modul_ = (ModulePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,1651,4088,9291,615,6721,944,1529,6367,8785,6426,7400,9774,2888,179], function() { return __webpack_exec__(34533); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);